import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { BancoService } from 'src/app/global/services/banco.service';
import { BancoServiceVM } from 'src/app/view-model/services/banco-vm.service';


@Injectable()
export class BancoProviderVM extends BancoServiceVM {
    constructor(private bancoService: BancoService) {
        super();
    }

    getBancos(): Observable<BancoResponse[]> {

        return this.bancoService.getBancos().pipe(
            (map(this.getBancosOK), catchError(this.serviceError))
        );
    }

    private getBancosOK(resp) {
        return resp;
    }

    private serviceError(error) {
        return throwError(error);
    }
}
